const services = [
  {
    icon: 'ri-megaphone-line',
    title: 'Brand Activation',
    desc: 'Turn your stretch tent into a powerful brand experience. Custom printed skins, branded installations, and immersive environments that put your identity front and centre at any activation, launch, or corporate event.',
    image: '/assets/img/decor-09.webp',
    imagePosition: 'center 65%',
  },
  {
    icon: 'ri-flashlight-line',
    title: 'Ambient & Fairy Light Setups',
    desc: 'Warm, atmospheric lighting that creates the perfect mood for any occasion, from elegant weddings to vibrant festivals. Fairy lights, Edison bulbs, and custom rigs.',
    image: '/assets/img/decor-14.webp',
  },
  {
    icon: 'ri-magic-line',
    title: 'Themed Decor & Styling',
    desc: 'Full event styling tailored to your theme, colour palette, and vision. We handle every detail from table centrepieces to entrance arches.',
    image: '/assets/img/db3ce5439ec9.webp',
  },
];

export default function Services() {
  return (
    <section className="py-20 bg-gray-50">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-14">
          <h2 className="text-4xl font-bold text-gray-900 mb-3">Our Decor Services</h2>
          <p className="text-gray-500 text-base max-w-xl mx-auto">
            Every element crafted to create a space that feels entirely your own.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {services.map((service, index) => (
            <div
              key={index}
              className="group bg-white rounded-2xl overflow-hidden border border-gray-100 hover:-translate-y-1 transition-transform duration-300 cursor-default"
            >
              {/* Image */}
              <div className="relative h-52 overflow-hidden bg-gray-100">
                <img
                  src={service.image}
                  alt={service.title}
                  style={{ objectPosition: service.imagePosition || 'top' }}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/30 to-transparent"></div>
              </div>

              {/* Content */}
              <div className="p-7">
                <div className="w-12 h-12 bg-teal-50 rounded-xl flex items-center justify-center mb-4">
                  <i className={`${service.icon} text-2xl text-teal-400`}></i>
                </div>
                <h3 className="text-lg font-bold text-gray-900 mb-3 leading-snug">
                  {service.title}
                </h3>
                <p className="text-gray-500 text-sm leading-relaxed">{service.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
